import { render } from "./PaginationResults.vue?vue&type=template&id=6d2fa240"
import script from "./PaginationResults.vue?vue&type=script&lang=js"
export * from "./PaginationResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__